var _circle, _circle2, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinish({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 149,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 74.5,
    fill: "#0b75c2",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 58.752,
    fill: "#0b75c2",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87.222,
    height: 87.224,
    x: 31.496,
    y: 30.285,
    fill: "#0b75c2",
    rx: 43.611
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.36 56.981q-.623-.045-1.248-.046v-2.423q.716 0 1.427.053zm4.855 1.09c-.776-.3-1.574-.542-2.386-.724l.53-2.365c.928.209 1.842.485 2.728.829zm3.32 1.72a18 18 0 0 0-1.064-.654l1.194-2.108q1.244.706 2.372 1.585l-1.49 1.912q-.492-.385-1.013-.732zm4.443 4.337a17 17 0 0 0-1.582-1.928l1.754-1.672c.654.69 1.26 1.43 1.81 2.205zm1.802 3.276a17 17 0 0 0-.518-1.134l2.163-1.09q.643 1.277 1.09 2.636l-2.301.758q-.195-.593-.434-1.17m1.284 6.074a17 17 0 0 0-.242-2.484l2.386-.412c.163.936.257 1.885.282 2.835l-2.423.06h-.003zm-.317 3.726q.12-.617.196-1.236l2.406.298a19 19 0 0 1-.557 2.798l-2.336-.646q.168-.6.291-1.214m-2.306 5.764c.445-.703.838-1.44 1.177-2.2l2.214.98a19.5 19.5 0 0 1-1.344 2.516zm-2.336 2.919q.444-.443.848-.916l1.836 1.582q-.466.54-.971 1.047z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.113 56.935a16.958 16.958 0 1 0 11.993 28.952l1.713 1.713a19.385 19.385 0 1 1-13.706-33.088z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.902 61.78a1.21 1.21 0 0 1 1.211 1.212v12.622l7.87 4.497a1.211 1.211 0 0 1-1.202 2.103l-8.48-4.846a1.21 1.21 0 0 1-.61-1.051V62.992a1.21 1.21 0 0 1 1.21-1.212z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.eb2105182732aa6e481bb926a3c851b5.svg";
export { ForwardRef as ReactComponent };